import {Action} from "@ngrx/store";

export const LOAD_INFO: string = '[info] Load Info';
export const LOAD_INFO_SUCCESS: string = '[info] Load Info Success';
export const LOAD_INFO_FAIL: string = '[info] Load Info Fail';

export class LoadInfo implements Action {
  readonly type: string = LOAD_INFO;
  constructor(public payload: number) {}
}

export class LoadInfoSuccess implements Action {

  readonly type: string = LOAD_INFO_SUCCESS;
  constructor(public payload: {
    websiteId: number,
    entities: {[websiteId: number]: any},
  }) {}

}

export class LoadInfoFail implements Action {

  readonly type: string = LOAD_INFO_FAIL;
  constructor(public payload: string) {}

}


export type InfoAction = LoadInfo | LoadInfoSuccess | LoadInfoFail;
